'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'

import topDestinationsData from '@/src/constants/topDestinations.json'

import { TopDestinations } from './topDestinations'

interface TopDestinationsData {
    title: string
    destinations: Array<{
        name_en: string
        name_ar?: string
        href_en: string
        href_ar?: string
    }>
}

export const TopDestinationsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const data = topDestinationsData as TopDestinationsData
    const isArabic = locale === 'ar'

    const destinations = useMemo(
        () =>
            data.destinations.map(destination => ({
                ...destination,
                name: isArabic ? destination.name_ar || destination.name_en : destination.name_en,
                href: isArabic ? destination.href_ar || destination.href_en : destination.href_en
            })),
        [data.destinations, isArabic]
    )

    if (!data || !data.destinations || data.destinations.length === 0) {
        return null
    }

    return <TopDestinations title={t('topDestinations')} destinations={destinations} />
}

export default TopDestinationsWrapper
